import createVuexEntities from '@/core/shared/orm/plugin/vuex-entities';
import schema from './schema';

export default [
  createVuexEntities(schema),
];
